export default "__VITE_ASSET__CBK0C4T4__$_?component__"